const map = {
	"./curriculum-preview.png": 177,
	"./eventomvpconf.jpg": 295,
	"./fotoarduinotcc.jpg": 795,
	"./fotopetvitaapresentacao.jpg": 78,
	"./new_img_1.jpg": 141,
	"./new_img_2.jpg": 242,
	"./new_img_3.jpg": 527,
	"./new_img_4.jpg": 212,
	"./palestramvpcarlos.jpg": 666,
	"./profile-photo.png": 943,
	"./tccsenai.png": 637,
	"./telahomepetvita.png": 189
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 793;